import React from "react";
import ServerError from "./ServerError";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, isRefreshingChunk: false };
    this.chunkReloadStorageKey = "__chunk_reload_attempted__";
    this.reloadTimer = null;
  }

  componentDidMount() {
    // Clear stale retry flag after a successful mount.
    if (typeof window !== "undefined") {
      sessionStorage.removeItem(this.chunkReloadStorageKey);
    }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentWillUnmount() {
    if (this.reloadTimer) {
      clearTimeout(this.reloadTimer);
      this.reloadTimer = null;
    }
  }

  componentDidCatch(error, errorInfo) {
    const errorName = error?.name || "";
    const errorMessage = error?.message || "";
    const isChunkLoadError =
      errorName === "ChunkLoadError" ||
      /Loading chunk [\w-]+ failed/i.test(errorMessage) ||
      /ChunkLoadError/i.test(errorMessage);

    if (isChunkLoadError && typeof window !== "undefined") {
      const alreadyRetried =
        sessionStorage.getItem(this.chunkReloadStorageKey) === "true";

      if (!alreadyRetried) {
        sessionStorage.setItem(this.chunkReloadStorageKey, "true");
        this.setState({ isRefreshingChunk: true });
        this.reloadTimer = setTimeout(() => {
          window.location.reload();
        }, 700);
        return;
      }
    }

    console.error("Error caught by ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.isRefreshingChunk) {
      return (
        <div className="min-h-screen w-full flex items-center justify-center bg-white">
          <div className="text-center px-6">
            <p className="text-lg font-medium text-[#231F20]">
              New version detected
            </p>
            <p className="text-sm text-gray-600 mt-2">
              Updating to the latest version...
            </p>
          </div>
        </div>
      );
    }

    if (this.state.hasError) {
      return <ServerError />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
